import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Button, Select, message, Card, Row, Col, Cascader,Spin } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import DynamicPicklistComponent from '../Components/MultiSelectPicklistComponent';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import CustomDrawer from '../Components/CustomDrawer';


import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { findAllByPlaceholderText } from '@testing-library/react';

const { Option } = Select;

const CreateListViewDrawer = ({ visible, onClose, object, fetchListViews, selectedListView,isListViewFromObjectPage,fetchRecords,currentPage,setSelectedView }) => {
  const [form] = Form.useForm();
  const [objectName, setObjectName] = useState([]);
  const [fields, setFields] = useState([]); // State to store fetched fields
  const [selectedFields, setSelectedFields] = useState([]);
  const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options
  const [logic, setLogic] = useState('');
  const [operator, setOperator] = useState('AND');
  const [isLogicEditable, setIsLogicEditable] = useState(false);
  const [filters, setFilters] = useState([{ 1: { field: '', value: '', displayValue: '' } }]); // For managing filters
  const [valueOperator, setValueOperator] = useState('');
  const [loading,setLoading]=useState(false);

  

  useEffect(() => {
    setObjectName(object.name);
    fetchFields();
  }, [object]);


  const isValidParentheses = (logic) => {
    let stack = [];
    for (let char of logic) {
      if (char === '(') {
        stack.push(char);
      } else if (char === ')') {
        if (stack.length === 0) {
          return false; // Unmatched closing parenthesis
        }
        stack.pop(); // Match found, pop the last open parenthesis
      }
    }
    return stack.length === 0; // Ensure all parentheses are closed
  };

  useEffect(() => {
    form.setFieldsValue({
      logic: logic, // Setting the field value whenever logic updates
    });
  }, [logic]);

  useEffect(() => {

    if (selectedListView) {
      // Set form values if editing an existing list view
      const transformedFields = (selectedListView.fields_to_display || []).map((field) => {
        if (field.endsWith('_id')) {
          const fieldWithoutId = field.replace('_id', '');
          return fieldWithoutId; // Capitalize first letter
        }
        return field; // Return the field as is if no '_id' suffix
      });


      form.setFieldsValue({
        list_view_name: selectedListView.list_view_name,
        object_name: selectedListView.object_name,
        logic: selectedListView.logic_string,
        fieldsToDisplay: transformedFields || [],
        sort_by: selectedListView.sort_by,
        sort_order: selectedListView.sort_order,
      });
      setSelectedFields(transformedFields || []);
      setLogic(selectedListView.logic_string);
      
      // Populate filters

      const existingFilters = selectedListView.conditions
        ? Object.entries(selectedListView.conditions).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';
          if (typeof value === 'object' && value !== null) {
            operator = Object.keys(value)[0]; // Extract operator ("$lt")
            actualValue = value[operator]; // Extract the actual value (20)
          } else {
            actualValue = value;
          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
      setFilters(existingFilters); // Set filters state here
      fetchLookupRecordsForExistingFilters(existingFilters); // Fetch lookup records for existing filters
    } else {
      // Reset form and filters if creating a new list view
      setFilters([{ field: '', value: '', displayValue: '' }]); // Reset filters state
      setLogic(''); // Reset logic when creating a new view
    }
  }, [selectedListView, form]);

   useEffect(() => {
      if (selectedListView && (filters !== null || filters !== undefined)) {
        fetchLookupRecordsForExistingFilters(filters);
      }
    }, [fields])

  const fetchFields = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_fields/object/${object.name}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      apiService.makeCall()
        .then(response => {
          // Assuming the API returns an array of field objects with 'name' and 'label' keys
          const filteredFields = response.filter(field => field.name !== 'recordCount' && !['textarea', 'richtext', 'address'].includes(field.type) ); // Filter out 'recordCount'
          // Update the state with the filtered fields
          setFields(filteredFields); // Adjust as per API response structure
        })
    } catch (error) {
    }
  };
  // New function to fetch lookup records based on existing filters
  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters.forEach(filter => {
      const selectedField = fields.find(field => field.name === filter.field?.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };
  // Function to fetch records for the lookup field
  const fetchLookupRecords = async (objectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response?.records?.map(record => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
      }));
      setLookupOptions(records); // Set options for the lookup field
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };
  const handleFieldChange = (value) => {
    // if (value.length > 7) {
    //   message.error('You can select up to 7 fields.');
    //   return;
    // }

    setSelectedFields(value);
  };
  
  const onFinish = async (values, saveAndNew = false) => {
    //Check if any filter is missing either field or value
    if (logic && !isValidParentheses(logic)) {
      message.error('Invalid logic: Parentheses are not balanced.');
      return; // Stop submission if parentheses are not balanced
    }
    let isValid = true;
    filters.forEach((filter, index) => {
      if (!filter.field) {
        isValid = false;
        // Show error message for the respective filter
        message.error(`Please enter field for filter ${index + 1}`);
      }
      //  else if(filter.operator && !filter.value){
      //   isValid = false;
      //   // Show error message for the respective filter
      //   message.error(`Please enter value for filter ${index + 1}`);
      //  }
    });
    if (!isValid) {
      return; // Stop the submission if validation fails
    }


   const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.operator && filter.value === "" 
            ? { [filter.operator]: "" }  // If operator exists and value is empty, set as JSON object
            : filter.value
        };
      }
      return acc;
    }, {});

    const adjustedFields = selectedFields.map((field) => {
      const selectedField = fields.find((f) => f.name === field);
      
      return field;
    });
 
    const body = {
      mt_list_view: {
        object_name: objectName,
        list_view_name: values.list_view_name,
        logic_string: logic,
        conditions: filterObj,
        fields_to_display: adjustedFields,
        sort_by: values.sort_by,
        sort_order: values.sort_order,
      },
    };
    try {
      setLoading(true);
      let responseData;
      if (selectedListView?._id) {
        // For updating an existing list view
        const apiServiceEdit = new ApiService(
          `${BASE_URL}/edit_list_view/${selectedListView?._id}`,
          { 'Content-Type': 'application/json' },
          'PATCH',
          body // Pass the request body
        );
       const response = await apiServiceEdit.makeCall();
       responseData = response;
        message.success('List view updated successfully!');
        //setListView(response);
        fetchListViews(); // Refresh the list views
        

      }
      else {
        // For creating a new list view
        const apiService = new ApiService(
          `${BASE_URL}/create_list_view`,
          { 'Content-Type': 'application/json' },
          'POST',
          body // Pass the request body
        );
        const response = await apiService.makeCall();
        responseData = response;
        message.success('List view created successfully!');
        //setListView(response);
        fetchListViews();
        setSelectedFields([]);
 
      }
      if(isListViewFromObjectPage){
        fetchRecords(responseData,currentPage);
        // setListView(selectedListView);
        setSelectedView(responseData);
        fetchListViews();
        setSelectedFields([]);

      }

       
    } catch (error) {
  
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save list view due to an unknown error';
      message.error(errorMessage);
      setSelectedFields([]);

    }
     finally{
      setLoading(false);
    }
    if (!saveAndNew) {
      onClose(); // Close the drawer for regular save
      form.resetFields();
      fetchListViews();
    } else {
      form.resetFields(); // Reset the form for new object creation
      fetchListViews();
    }
   
  };

  
  return (
  

    <CustomDrawer
            title={selectedListView?._id ? 'Edit List View' : 'Create List View'}
            visible={visible}
            zIndex={1002}   // higher than sidebar
            onClose={!loading ? onClose : null}
            closable={false}
            footer={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '8px'  }}>
         <div>
          <Button onClick={() => {
            form.resetFields(); // Reset form fields when Cancel is clicked
            onClose(); // Close the drawer
          }}>
            Cancel
          </Button>
          </div>
          <div>
          <Button  style={{
              marginRight: '16px',
            }} onClick={() => {
            form.validateFields().then((values) => {
              onFinish(values, true); // Pass a flag to differentiate Save & New
            });
          }}  type="primary">Save & New</Button>
          <Button onClick={() => form.submit()} type="primary">
            Save
          </Button>
          </div>
        </div> 
          }
        >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={onFinish} >
          <Form.Item name="object_name" label="Object Name" >
            <Input defaultValue={object.name} disabled />
          </Form.Item>
          <Form.Item name="list_view_name" label="List View Name" rules={[{ required: true, message: 'Please enter a list view name' }]}>
            <Input placeholder="Enter list view name" />
          </Form.Item>
          <Form.Item
            name="fieldsToDisplay"
            label="Fields to Display"
            rules={[{ required: true, message: 'Please select at least one field' }]}
          > 
            <DynamicPicklistComponent
              onChange={handleFieldChange}
              isSelect={true}
              selectedFields={selectedFields}
              selectOptions={fields}
            >
            </DynamicPicklistComponent>
            

          </Form.Item>
          <Form.Item name="sort_by" label="Sort By">
            <Select placeholder="Select sort field">
              <Option value="created_at">Created At</Option>
              <Option value="Name">Name</Option>
            </Select>
          </Form.Item>
          <Form.Item name="sort_order" label="Sort Order">
            <Select placeholder="Select sort order">
              <Option value="asc">Ascending</Option>
              <Option value="desc">Descending</Option>
            </Select>
          </Form.Item> 
          {/* Filter Section */}
          <FiltersDynamic
            fields={fields}
            logic={logic}
            setLogic={setLogic}
            filters={filters}
            setFilters={setFilters}
            setValueOperator={setValueOperator}
            valueOperator={valueOperator}
            fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
            fetchLookupRecords={fetchLookupRecords}
            lookupOptions={lookupOptions}
          >
          </FiltersDynamic>
        </Form>
        </Spin>
    </CustomDrawer>
  );
};
export default CreateListViewDrawer;